export const PAYMENT_METHOD_CREDIT_CARD = "CreditCard";
export const PAYMENT_METHOD_ACCOUNT_2_ACCOUNT = "Account2Account";
